import { Box, Button, Typography } from '@mui/material';
import mobArrow from '../../../../Assets/images/downArrow.svg';
import step1 from '../../../../Assets/images/step1.svg';
import step2 from '../../../../Assets/images/step2.svg';
import step3 from '../../../../Assets/images/step3.svg';
import step4 from '../../../../Assets/images/step4.svg';
import arrow from '../../../../Assets/images/stepArrow.svg';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import { useStyles } from './styles';

const steps = [
  {
    step: 'Step 01',
    title: 'Submit your application',
    description: 'Tell us what you’re building. We’re listening closely.',
    iconSrc: step1,
  },
  {
    step: 'Step 02',
    title: 'Internal Evaluation',
    description: 'Our team will review your application and select which startups proceed to the next round.',
    iconSrc: step2,
  },
  {
    step: 'Step 03',
    title: 'We Reach Out',
    description: 'We’ll get in touch with shortlisted startups for deeper conversations and next steps.',
    iconSrc: step3,
  },
  {
    step: 'Step 04',
    title: 'Pitch Your Idea',
    description: 'Finalists will pitch on national television to a jury of expert investors with funding, mentorship, and national visibility on the table.',
    iconSrc: step4,
  },
];

const HowItWorks = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.section}>
      <Box className={classes.content}>
        <Box className={classes.header}>
          <Box>
            <Typography className={classes.title}>How it works</Typography>
            <Typography className={classes.subtitle}>From idea to impact, here’s a step-by-step overview and selection process.</Typography>
          </Box>
          <Box mt={2}>
            <Button className={classes.ApplyNowBtn} onClick={() => navigate(routes.signup)}>
              Apply to pitch
            </Button>
          </Box>
        </Box>
        <Box className={classes.cardsWrapper}>
          {steps.map((step, index) => (
            <Box key={index} className={classes.card}>
              <Typography className={classes.step}>{step.step}</Typography>
              <Typography className={classes.cardTitle}>{step.title}</Typography>
              <Typography className={classes.cardDesc}>{step.description}</Typography>
              <Box className={classes.icon}>
                <img src={step.iconSrc} alt={step.title} className={classes.iconImage} />
              </Box>
              {index < steps.length - 1 && (
                <>
                  <Box className={`${classes.arrow} ${index === 1 || index === 3 ? classes.hideOnSmall : ''}`}>
                    <img src={arrow} alt="Next step" className={classes.arrowImage} />
                  </Box>

                  <Box className={`${classes.arrowMobile} ${classes.showOnlyOnSmall}`}>
                    <img src={mobArrow} alt="Next step mobile" className={classes.arrowImageMobile} />
                  </Box>
                </>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default HowItWorks;
